var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconApps = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Apps") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Apps",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Combined-Shape",
    fill: "#029DD0",
    x: 0.000245606173,
    y: 3.96482847e-12,
    width: 49.998894,
    height: 40.4,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.64505382,21.3373073 L23.4417546,15.0786541 C24.4378639,14.6573235 25.5621361,14.6573235 26.5582454,15.0786541 L41.3905468,21.3523655 C42.8616046,21.9745881 43.8214874,23.4123089 43.8322112,25.0095118 L44,50 L44,50 L6.37091865,50 L6.2033894,25.0481652 C6.19253449,23.4314332 7.1560093,21.9671378 8.64505382,21.3373073 Z",
    id: "Rectangle",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2700697,48.6685445 C24.2700697,48.8442587 24.23528,49.0182343 24.1677072,49.1804361 C23.8849973,49.8590536 23.1056874,50.1800002 22.4270698,49.8972902 L9.01867626,44.3113955 C8.52260395,44.1047333 8.19945963,43.6200481 8.19945963,43.0826498 L8.19945963,26.4863683 C8.19945963,26.3105982 8.23427144,26.1365686 8.30188586,25.9743237 C8.58468027,25.2957413 9.36403013,24.9748918 10.0426125,25.2576862 L23.451006,30.8455399 C23.946997,31.0522406 24.2700697,31.5368839 24.2700697,32.0742219 L24.2700697,48.6685445 Z",
    id: "Path",
    fill: "#054169",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7299303,48.6685445 C25.7299303,48.8442587 25.76472,49.0182343 25.8322928,49.1804361 C26.1150027,49.8590536 26.8943126,50.1800002 27.5729302,49.8972902 L40.9813237,44.3113955 C41.477396,44.1047333 41.8005404,43.6200481 41.8005404,43.0826498 L41.8005404,26.4863683 C41.8005404,26.3105982 41.7657286,26.1365686 41.6981141,25.9743237 C41.4153197,25.2957413 40.6359699,24.9748918 39.9573875,25.2576862 L26.548994,30.8455399 C26.053003,31.0522406 25.7299303,31.5368839 25.7299303,32.0742219 L25.7299303,48.6685445 Z",
    id: "Path",
    fill: "#054169",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7210436,21.6960482 C38.0283972,21.8241324 38.2726953,22.068467 38.4007336,22.3758397 C38.6688119,23.0193965 38.3644265,23.7584229 37.7208696,24.0265012 L25.4853988,29.1232766 C25.1747373,29.2526849 24.8252627,29.2526849 24.5146012,29.1232766 L12.2791304,24.0265012 C11.9717577,23.8984629 11.7274231,23.6541648 11.5993389,23.3468112 C11.3311645,22.7032944 11.6354396,21.9642226 12.2789564,21.6960482 L24.5144272,16.5971287 C24.82519,16.4676238 25.17481,16.4676238 25.4855728,16.5971287 L37.7210436,21.6960482 Z",
    id: "Path",
    fill: "#029DD0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,5.32907052e-15 L45.9991396,5.32907052e-15 C48.2082786,9.99039097e-16 49.9991396,1.790861 49.9991396,4 L49.9991396,10.6739212 L49.9991396,10.6739212 L-3.55271368e-15,10.6739212 L-3.55271368e-15,4 C-3.82325518e-15,1.790861 1.790861,5.73488277e-15 4,5.32907052e-15 Z",
    id: "Rectangle",
    fill: "#054169"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#E5F8FD",
    cx: 30.7598611,
    cy: 5.3369606,
    r: 2.39174826
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#E5F8FD",
    cx: 37.7904989,
    cy: 5.3369606,
    r: 2.39174826
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#E5F8FD",
    cx: 44.8211367,
    cy: 5.3369606,
    r: 2.39174826
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconApps);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Icon-Apps.4f784c4e02d0b74356a9534af2ed28dd.svg";